module.exports = __webpack_public_path__ + "static/media/ic_logo_footer.29a01fff.svg";